/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Login_Method_Revoked_DescInputs */



/**
* | output |
* | --- |
* | "The member can no longer sign in this way. Their other sign-in methods, their passkeys and their active sessions are unaffected." |
*
* @param {Audit_Details_Member_Login_Method_Revoked_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_login_method_revoked_desc = /** @type {((inputs?: Audit_Details_Member_Login_Method_Revoked_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Login_Method_Revoked_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Mitglied kann sich auf diesem Weg nicht mehr anmelden. Die übrigen Anmeldemethoden, die Passkeys und die aktiven Sitzungen bleiben unberührt.")
	return /** @type {LocalizedString} */ ("The member can no longer sign in this way. Their other sign-in methods, their passkeys and their active sessions are unaffected.")
});